<template>
  <div>
    <com-dialog :visible.sync="visible" width="50%" title="生成设备">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="批次" prop="name">
            <el-input v-model="ruleForm.name" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="生成数量" prop="number">
            <el-input v-model="ruleForm.number" placeholder=""></el-input>
          </el-form-item>
        </el-form>
        <div class="mt-15px flex justify-end">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disabled"
            >确定</el-button
          >
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { addEquBatchApi } from '@/api/equ'

export default {
  data() {
    return {
      visible: false,
      ruleForm: {},
      disabled: false,
      rules: {
        name: [{ required: true, message: '请输入批次', trigger: 'blur' }],
        number: [{ required: true, message: '请输入生成数量', trigger: 'blur' }]
      }
    }
  },
  methods: {
    baseRuleForm() {
      return {
        name: '',
        number: ''
      }
    },
    open() {
      this.ruleForm = this.baseRuleForm()
      this.visible = true
    },
    close() {
      this.visible = false
    },
    submitForm(formName) {
      // eslint-disable-next-line consistent-return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('通过 :>> ')
          this.disabled = true
          addEquBatchApi(this.ruleForm)
            .then((res) => {
              console.log('res :>> ', res)
              this.$emit('success')
              this.disabled = false
              this.close()
            })
            .catch(() => {
              this.disabled = false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
